import { BrowserRouter } from "react-router-dom";
import { Router } from "./router/Router";
import awsmobile from "./modules/amplify/awsmobile";

export default function App() {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}
